module.exports = __webpack_public_path__ + "static/lageplan_freizeitsport-5b386b7977fca818bb02d94fe508d691.png";